import { TugOfWar } from "@/components/TugOfWar";
import "./index.css";

export function App() {
	return (
		<div className="h-screen w-screen overflow-hidden bg-gradient-to-br from-slate-50 via-white to-sky-50">
			<TugOfWar />
		</div>
	);
}

export default App;
